import { render } from "./SearchContentListItem.vue?vue&type=template&id=54b4623e"
import script from "./SearchContentListItem.vue?vue&type=script&lang=js"
export * from "./SearchContentListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__